

// const atencionTerapiasLS = localStorage.getItem('atencionTerapias')
//   ? JSON.parse(localStorage.getItem('atencionTerapias'))
//   : [];


export default {
  state:{
    terapiasList: [],
  },

  
  mutations: {

    setTerapiasList( state, data) {
      state.terapiasList = data
    },

    resetTerapias( state ) {
      state.terapiasList = []
    }
  }
}

